export const environment = {
    production: false,
    auth: {
        domain: 'aitabletalk.us.auth0.com',
        clientId: 'ATtXUotpNzDwrtM3czM7Q9rl6BY8gxvs',
        redirectUri: 'http://localhost:4200', //Not used
        audience: 'https://aitabletalk.us.auth0.com/api/v2/',
        hasuraSecretKey: '*-u7\'F4^TVM_Nuv8QqTHnzc;=U&$(-!&',
        hasuraApiUrl: 'https://dnyyeezkefpglpfrudiu.hasura.ap-south-1.nhost.run/v1/graphql',
        serviceApiUrl: 'https://table-talk-server-open-ai-production.vercel.app/api', //https://tabletalk-server-openai.vercel.app
        apiUrl: 'https://table-talk-backend-production.vercel.app',//'https://q6wq78yljd.execute-api.ap-south-1.amazonaws.com/staging',
        serverUrl: 'https://table-talk-server-open-ai-production.vercel.app'//https://tabletalk-server-openai.vercel.app
    }
};
